import { render, staticRenderFns } from "./ResizableFrame.vue?vue&type=template&id=bf4571b0&scoped=true&"
import script from "./ResizableFrame.vue?vue&type=script&lang=js&"
export * from "./ResizableFrame.vue?vue&type=script&lang=js&"
import style0 from "./ResizableFrame.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ResizableFrame.vue?vue&type=style&index=1&id=bf4571b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4571b0",
  null
  
)

export default component.exports